export default __webpack_public_path__ + "static/media/pc04-1.c9045b34.png";